import ee from "lodash.clonedeep";
import { jsx as g, jsxs as S, Fragment as G } from "preact/jsx-runtime";
import ie from "preact/compat";
import { parse as ne } from "css";
import { renderToStaticMarkup as re } from "preact-render-to-string";
import mt from "opentype.js";
import ae from "exifreader";
import { dataUriToBuffer as se } from "data-uri-to-buffer";
import { Pith as oe } from "pith";
const v = () => {
  const t = () => Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  return t() + t() + "-" + t() + "-" + t() + "-" + t() + "-" + t() + t() + t();
};
var x = /* @__PURE__ */ ((t) => (t.Frame = "frame", t.Group = "group", t.Image = "image", t.Illustration = "illustration", t.Textbox = "textbox", t))(x || {}), At = /* @__PURE__ */ ((t) => (t.ThreeD = "ThreeD", t.FreeDesign = "FreeDesign", t.Print = "Print", t))(At || {}), k = /* @__PURE__ */ ((t) => (t.Autosize = "Autosize", t.Traditional = "Traditional", t))(k || {}), le = /* @__PURE__ */ ((t) => (t.Pixel = "px", t.Millimeter = "mm", t.Centimeter = "cm", t))(le || {}), C = /* @__PURE__ */ ((t) => (t[t.North = 0] = "North", t[t.Northeast = 1] = "Northeast", t[t.East = 2] = "East", t[t.Southeast = 3] = "Southeast", t[t.South = 4] = "South", t[t.Southwest = 5] = "Southwest", t[t.West = 6] = "West", t[t.Northwest = 7] = "Northwest", t))(C || {}), ce = /* @__PURE__ */ ((t) => (t.Show = "Show", t))(ce || {}), he = /* @__PURE__ */ ((t) => (t.FileUpload = "FileUpload", t.Option = "Option", t.ColorOption = "ColorOption", t.Text = "Text", t))(he || {}), de = /* @__PURE__ */ ((t) => (t.None = "None", t.RemoveWhenSelected = "RemoveWhenSelected", t.ApplyWhenSelected = "ApplyWhenSelected", t))(de || {}), ue = /* @__PURE__ */ ((t) => (t.Data = "Data", t.Font = "Font", t.Frame = "Frame", t.Illustration = "Illustration", t.Image = "Image", t.Model = "Model", t.Material = "Material", t.Color = "Color", t.QuestionnaireCollateral = "QuestionnaireCollateral", t.RequestCollateral = "RequestCollateral", t.SignupCollateral = "SignupCollateral", t.Video = "Video", t.ColorProfile = "ColorProfile", t.Environment = "Environment", t))(ue || {}), ge = /* @__PURE__ */ ((t) => (t.Information = "Information", t.Bulk = "Bulk", t.DigitalContent = "DigitalContent", t.Finish = "Finish", t.Frame = "Frame", t.Illustration = "Illustration", t.Introduction = "Introduction", t.Material = "Material", t.Model = "Model", t.Module = "Module", t.Picture = "Picture", t.Photo = "Photo", t.ProductOverlay = "ProductOverlay", t.Question = "Question", t.Shape = "Shape", t.SilentIllustration = "SilentIllustration", t.Text = "Text", t))(ge || {}), fe = /* @__PURE__ */ ((t) => (t.Color = "Color", t.Colors = "Colors", t.Selection = "Selection", t.Selections = "Selections", t.Text = "Text", t.Upload = "Upload", t))(fe || {});
const me = ({
  backgroundColor: t,
  outlineColor: e,
  borderRadius: i,
  configuration: n,
  elements: r,
  height: a,
  maxHeight: s,
  maxWidth: o,
  outlineArea: l,
  position: c,
  preserveAspectRatio: h,
  viewBox: d,
  width: u
}) => {
  var K;
  const f = i || 0, m = 2 * ((l == null ? void 0 : l.scale) || 1), A = d || {
    x: 0,
    y: 0,
    width: u,
    height: a
  }, B = `${A.x} ${A.y} ${A.width} ${A.height}`, b = v(), p = n.purpose === At.FreeDesign && g("defs", {
    children: g("clipPath", {
      id: "viewboxClip",
      children: g("rect", {
        width: A.width,
        height: A.height,
        rx: f
      })
    })
  }), D = (K = n.colorProfiles) == null ? void 0 : K.map((M, $) => (
    /* @ts-ignore */
    g("color-profile", {
      name: M.name,
      xlinkHref: M.key,
      children: " "
    }, $)
  )), N = r.map((M) => ({
    ...M,
    _renderingConfiguration: n,
    mask: l ? `url(#viewmask-${b})` : void 0
  })), L = It(N);
  return S("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    version: "1.1",
    preserveAspectRatio: h,
    width: u,
    height: a,
    style: {
      gridColumn: 1,
      gridRow: 1,
      maxWidth: o,
      maxHeight: s,
      position: c
    },
    viewBox: B,
    children: [D, p, !!t && g("rect", {
      id: "layout-background",
      width: A.width,
      height: A.height,
      fill: t,
      rx: f
    }), g("g", {
      id: "element-group",
      clipPath: n.purpose === At.FreeDesign ? "url(#viewboxClip)" : void 0,
      children: L.map((M) => Kt(M)).filter((M) => !!M)
    }), l && g("rect", {
      x: l.x,
      y: l.y,
      width: l.width,
      height: l.height,
      fill: "none",
      stroke: l.hidden ? "none" : e || "#aaaaaa",
      strokeWidth: m / 2,
      strokeDasharray: `${m * 2} ${m}`
    }), l && S("mask", {
      id: `viewmask-${b}`,
      children: [g("rect", {
        x: A.x,
        y: A.y,
        width: A.width,
        height: A.height,
        fill: "black"
      }), g("rect", {
        x: l.x,
        y: l.y,
        width: l.width,
        height: l.height,
        fill: "white"
      })]
    })]
  });
}, yi = (t, e, i, n, r) => {
  const a = P(r), s = i / 2, o = n / 2, l = t + s, c = e + o, h = Math.sin(a), d = Math.cos(a), u = s, f = s, m = -o, A = o, B = u * d - m * h, b = f * d - A * h, p = u * h + m * d, D = f * h + A * d, N = Math.max(Math.abs(B), Math.abs(b)), L = Math.max(Math.abs(p), Math.abs(D));
  return {
    minX: l - N,
    maxX: l + N,
    minY: c - L,
    maxY: c + L
  };
}, wi = (t, e, i) => {
  const n = Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2)), r = Math.sqrt(Math.pow(e.x - i.x, 2) + Math.pow(e.y - i.y, 2)), a = Math.sqrt(Math.pow(i.x - t.x, 2) + Math.pow(i.y - t.y, 2));
  return Math.acos((r * r + n * n - a * a) / (2 * r * n)) * (180 / Math.PI);
}, P = (t) => t * (Math.PI / 180), xi = (t) => t * (180 / Math.PI), vi = (t, e, i) => Math.abs(t - e) < i, Ei = (t, e, i) => {
  const n = Math.sin(P(i)), r = Math.cos(P(i));
  return {
    x: (t.x - e.x) * r - (t.y - e.y) * n + e.x,
    y: (t.x - e.x) * n + (t.y - e.y) * r + e.y
  };
}, bi = (t, e) => ({
  x: (t.x + e.x) / 2,
  y: (t.y + e.y) / 2
}), Ci = (t, e, i, n) => ({
  x: t.x + (e == null ? void 0 : e.x) * i,
  y: t.y + (e == null ? void 0 : e.y) * n
}), Ii = (t, e, i, n) => ({
  x: t.x + ((e == null ? void 0 : e.x) + (e == null ? void 0 : e.width)) * i,
  y: t.y + (e == null ? void 0 : e.y) * n
}), Bi = (t, e, i, n) => ({
  x: t.x + (e == null ? void 0 : e.x) * i,
  y: t.y + ((e == null ? void 0 : e.y) + (e == null ? void 0 : e.height)) * n
}), Fi = (t, e, i, n) => ({
  x: t.x + ((e == null ? void 0 : e.x) + (e == null ? void 0 : e.width)) * i,
  y: t.y + ((e == null ? void 0 : e.y) + (e == null ? void 0 : e.height)) * n
}), j = (t) => {
  switch (t) {
    case C.North:
      return C.East;
    case C.East:
      return C.South;
    case C.South:
      return C.West;
    case C.West:
      return C.North;
    case C.Northwest:
      return C.Northeast;
    case C.Northeast:
      return C.Southeast;
    case C.Southeast:
      return C.Southwest;
    case C.Southwest:
      return C.Northwest;
  }
}, Si = (t, e) => e > 45 && e <= 135 ? j(t) : e > 135 && e <= 225 ? j(j(t)) : e > 225 && e <= 315 ? j(j(j(t))) : t, Mi = (t, e = {
  x: 0,
  y: 0
}, i = {
  x: 1,
  y: 1
}) => {
  const n = P(t.rotation), r = {
    x: e.x + t.x * i.x,
    y: e.x + t.y * i.y
  }, a = {
    x: t.x + t.width,
    y: t.y
  }, s = {
    x: e.x + (t.x + t.width) * i.x,
    y: e.y + (t.height + t.y) * i.y
  }, o = {
    x: e.x + t.x * i.x,
    y: e.y + (t.height + t.y) * i.y
  }, l = {
    x: (o.x + s.x) / 2,
    y: o.y - t.height * i.y / 2
  };
  return {
    a: Z(r, l, n),
    b: Z(a, l, n),
    c: Z(s, l, n),
    d: Z(o, l, n),
    center: l
  };
}, Z = (t, e, i) => {
  const n = Math.sin(i), r = Math.cos(i);
  return {
    x: (t.x - e.x) * r - (t.y - e.y) * n + e.x,
    y: (t.x - e.x) * n + (t.y - e.y) * r + e.y
  };
}, Di = 0.352778, pi = 0.035277, jt = (t) => {
  const e = t.rotation || 0, i = P(e), n = Math.cos(i), r = -Math.sin(i);
  return g("g", {
    mask: t.stepName || t.productOverlay ? void 0 : t.mask,
    children: g("g", {
      transform: `
                matrix(1, 0, 0, 1, ${t.x}, ${t.y})
                matrix(1, 0, 0, 1, ${t.width / 2}, ${t.height / 2})
                matrix(${n}, ${-r}, ${r}, ${n}, 0, 0)
                matrix(1, 0, 0, 1, ${-t.width / 2}, ${-t.height / 2})
                `,
      children: g("image", {
        xlinkHref: t.src,
        preserveAspectRatio: t.preserveAspectRatio,
        width: t.width,
        height: t.height
      })
    })
  });
}, Ae = "data:image/png;base64,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", J = (t) => {
  const e = Ot(t.spotColor);
  return e ? `${t.browserValue} ${e}` : t.browserValue;
}, Ot = (t) => {
  if (!t)
    return "";
  if (t.profileName.includes("/") && t.profileName.includes(".icc")) {
    const e = t.profileName.replace(/\s/g, "-"), i = e.lastIndexOf("/");
    return `icc-named-color(${e.slice(i + 1).slice(0, -4)}, ${t.namedColor})`;
  }
  return `icc-named-color(${t.profileName}, ${t.namedColor})`;
}, Ft = (t) => {
  const e = t.split(/[ ](?=[^)]*?(?:\(|$))/);
  if (e.length === 0)
    return {
      browserValue: "#000000"
    };
  if (e.length === 1)
    return {
      browserValue: e[0]
    };
  const i = e[1].match(/\(([^)]+)\)/gm);
  if (!i)
    throw new Error("Unhandled state of color value in SVG");
  const n = i[0].replace(/[() ]/g, "").split(",");
  return {
    browserValue: e[0],
    spotColor: {
      profileName: n[0],
      namedColor: n[1]
    }
  };
};
let yt, wt;
function Qi(t) {
  yt = t;
}
function Pi(t) {
  wt = t;
}
function ot() {
  if (!yt)
    throw new Error("DOM constructor is not registered. Please register it before calling this function.");
  return new yt();
}
function U(t, e) {
  if (!wt) {
    if (typeof window < "u" && window.fetch)
      return window.fetch(t, e);
    if (typeof global < "u" && global.fetch)
      return global.fetch(t, e);
    throw new Error("Fetch implementation is not registered. Please register it before calling this function.");
  }
  return wt(t, e);
}
const kt = /* @__PURE__ */ new Map(), St = /* @__PURE__ */ new Map(), Mt = /* @__PURE__ */ new Map(), Wt = async (t) => {
  const e = St.get(t);
  if (e)
    return e;
  const n = (async () => {
    var a;
    const r = await U(t);
    return kt.set(t, ((a = r.headers) == null ? void 0 : a.get("content-type")) || ""), await r.arrayBuffer();
  })();
  return St.set(t, n), n;
}, ye = async (t) => {
  const e = Mt.get(t);
  if (e)
    return e;
  const n = (async () => await (await U(t)).text())();
  return Mt.set(t, n), n;
}, V = (t) => t.every((e) => e !== "undefined"), Ni = (t) => V([typeof document]) ? document.createElement(t) : ot().window.document.createElement(t), Li = (t, e) => {
  if (V([typeof document]))
    return document.createElementNS(t, e);
  const n = ot().window.document.createElement(e);
  return n.setAttribute("xmlns", t), n;
}, W = () => {
  if (V([typeof DOMParser]))
    return new DOMParser();
  const t = ot();
  return new t.window.DOMParser();
}, bt = (t, e) => new Promise((i, n) => {
  e ? Wt(t).then(i).catch(n) : U(t).then((r) => {
    r.arrayBuffer().then(i).catch(n);
  }).catch((r) => {
    n(r);
  });
}), X = (t, e) => new Promise((i, n) => {
  e ? ye(t).then(i).catch(n) : U(t).then((r) => {
    r.text().then(i).catch(n);
  }).catch(n);
}), ji = (t) => re(t), lt = /* @__PURE__ */ new Map(), we = async (t, e) => {
  if (V([typeof FontFace])) {
    if (lt.has(e))
      return lt.get(e);
    const i = t.names.fullName.en, n = new FontFace(i, `url(${e})`);
    document.fonts.add(n);
    const r = n.load();
    return lt.set(e, r), r;
  }
}, zt = () => {
  if (V([typeof XMLSerializer]))
    return new XMLSerializer();
  const t = ot();
  return new t.window.XMLSerializer();
}, Oi = (t) => btoa(t), q = (t) => {
  function e() {
    const n = new Uint8Array(t), r = 4;
    if (n.length >= r) {
      let a = new Array(r);
      for (let l = 0; l < r; l++)
        a[l] = new Uint8Array(t)[l].toString(16);
      const s = a.join("").toUpperCase();
      switch (s) {
        case "89504E47":
          return "image/png";
        case "47494638":
          return "image/gif";
        case "25504446":
          return "application/pdf";
        case "504B0304":
          return "application/zip";
      }
      switch (s.slice(0, 4)) {
        case "FFD8":
          return "image/jpeg";
      }
    }
    return null;
  }
  const i = e();
  return i || "image/svg+xml";
}, ki = async (t) => {
  const e = await Wt(t), i = kt.get(t) || q(e);
  return await be(new Blob([e], {
    type: i
  }));
}, xe = (t) => {
  let e = "";
  const i = t.byteLength;
  for (let n = 0; n < i; n++)
    e += String.fromCharCode(t[n]);
  return e;
}, ve = async (t) => {
  const e = q(t), i = new Uint8Array(t), n = xe(i), r = btoa(n);
  return `data:${e};base64,${r}`;
}, Ee = (t) => `data:image/svg+xml;base64,${btoa(t)}`, Ht = (t) => {
  const e = t.replace(/\r?\n/g, ""), i = e.indexOf(",");
  if (i === -1 || i <= 4)
    throw new TypeError("malformed data: URI");
  const n = e.substring(5, i).split(";");
  let r = !1;
  for (let s = 1; s < n.length; s++)
    n[s] === "base64" && (r = !0);
  const a = decodeURI(e.substring(i + 1));
  return r ? new Uint8Array(atob(a).split("").map((o) => o.charCodeAt(0))).buffer : new Uint8Array(a.split("").map((o) => o.charCodeAt(0))).buffer;
}, be = (t) => new Promise((e, i) => {
  const n = new FileReader();
  n.onload = function(r) {
    const a = r.target;
    !a || !a.result ? i() : e(a.result.toString());
  }, n.readAsDataURL(t);
}), Ce = ["altGlyph", "circle", "ellipse", "path", "polygon", "polyline", "rect", "text", "textPath", "tref", "tspan"], Ie = ["fill", "stroke"], T = (t, e) => {
  e(t), t.children.length > 0 && Array.from(t.children).forEach((i) => T(i, e));
}, Be = (t, e) => {
  try {
    return t.matches(e);
  } catch {
    return t.classList.contains(e.substring(1));
  }
}, Fe = (t, e = !1) => {
  !e && t.setAttribute("preserveAspectRatio", "none");
  const i = [];
  T(t, (n) => {
    var a, s, o;
    if (n.tagName === "script") {
      n.remove();
      return;
    }
    if (n.tagName === "style") {
      try {
        (a = ne(n.innerHTML).stylesheet) == null || a.rules.forEach((c) => {
          i.push(c);
        }), n.remove();
      } catch (l) {
        console.error(l);
      }
      return;
    }
    const r = (o = (s = n.attributes.getNamedItem("style")) == null ? void 0 : s.value) == null ? void 0 : o.trim();
    if (r) {
      const l = [];
      r.split(";").forEach((h) => {
        const d = h.trim();
        if (d) {
          const [u, f] = d.split(":"), m = u.toLowerCase();
          Ie.indexOf(m) > -1 ? n.setAttribute(m, f.trim()) : l.push(d);
        }
      }), l.length > 0 ? n.setAttribute("style", l.join(";")) : n.removeAttribute("style");
    }
  }), T(t, (n) => {
    i.forEach((r) => {
      var a;
      (a = r.selectors) == null || a.forEach((s) => {
        var o;
        Be(n, s) && ((o = r.declarations) == null || o.forEach((l) => {
          l.property && l.value && n.setAttribute(l.property, l.value);
        }));
      });
    });
  });
}, Rt = (t) => W().parseFromString(t, "image/svg+xml").firstElementChild, Se = (t, e, i) => {
  t.setAttribute("height", `${i}px`), t.setAttribute("width", `${e}px`);
}, Gt = (t, e, i) => {
  T(t, (n) => {
    const r = n.attributes.getNamedItem("fill");
    r && r.value !== "none" && n.classList.forEach((s) => {
      if (s.startsWith("spiff-fill")) {
        const o = e[s.replace("spiff-fill-", "")];
        if (o)
          n.setAttribute("fill", i ? J(o) : o.browserValue);
        else {
          const l = e[s];
          l && n.setAttribute("fill", i ? J(l) : l.browserValue);
        }
      }
    });
    const a = n.attributes.getNamedItem("stroke");
    a && a.value !== "none" && n.classList.forEach((s) => {
      if (s.startsWith("spiff-stroke")) {
        const o = e[s.replace("spiff-stroke-", "")];
        if (o)
          n.setAttribute("stroke", i ? J(o) : o.browserValue);
        else {
          const l = e[s];
          l && n.setAttribute("fill", i ? J(l) : l.browserValue);
        }
      }
    });
  });
}, Xt = (t) => zt().serializeToString(t), Tt = (t, e, i, n, r) => {
  const a = Rt(t);
  if (!a)
    throw new Error("Failed to read SVG.");
  return Se(a, e, i), Gt(a, n, r), Xt(a);
}, Me = (t, e, i) => {
  const n = Rt(t);
  if (!n)
    throw new Error("Failed to read SVG.");
  return Gt(n, e, i), Xt(n);
}, De = (t) => {
  const e = /<svg.*<\/svg>/s, i = t.match(e) || [], n = (i == null ? void 0 : i.length) > 0 ? i[0] : "";
  return W().parseFromString(n, "image/svg+xml");
}, rt = async (t) => {
  const i = De(t).firstElementChild;
  if (!i)
    throw new Error("Failed to read SVG.");
  Fe(i);
  const n = {};
  T(i, (s) => {
    Ce.includes(s.tagName) && !s.attributes.getNamedItem("fill") && s.setAttribute("fill", "black");
    const o = s.attributes.getNamedItem("fill");
    if (o && o.value !== "none" && !o.value.startsWith("url(")) {
      const c = Ft(o.value), h = c.browserValue.replace(/\W/g, ""), d = `spiff-fill-${h}`;
      s.setAttribute("fill", c.browserValue), s.classList.add(d), n[h] = c;
    }
    const l = s.attributes.getNamedItem("stroke");
    if (l && l.value !== "none" && !l.value.startsWith("url(")) {
      const c = Ft(l.value), h = c.browserValue.replace(/\W/g, ""), d = `spiff-stroke-${h}`;
      s.classList.add(d), s.setAttribute("stroke", c.browserValue), n[h] = c;
    }
  });
  const a = zt().serializeToString(i);
  return {
    colors: n,
    svg: a
  };
}, _ = 256, Dt = 256, pe = (t) => {
  const e = `spiff-frame-${t.id}`, i = `spiff-frame-blur-${t.id}`, n = `spiff-frame-blur-edge-${t.id}`, r = `spiff-frame-focal-mask-${t.id}`, a = `spiff-frame-threshold-${t.id}`, s = () => {
    if (t.disablePlaceholder && !t.pattern)
      return "";
    if (!t.pattern)
      return Ae;
    if (t.pattern.svg) {
      const m = Me(t.pattern.svg, t.pattern.colors || {}, !1);
      return Ee(m);
    }
    return t.pattern.src;
  };
  if (!s())
    return g(ie.Fragment, {});
  const o = () => t.threshold ? t.invertThreshold ? "1 ".repeat(t.threshold) + "0 ".repeat(256 - t.threshold) : "0 ".repeat(t.threshold) + "1 ".repeat(256 - t.threshold) : "", l = (m) => {
    var M, $;
    const A = ((M = t.pattern) == null ? void 0 : M.x) || 0, B = (($ = t.pattern) == null ? void 0 : $.y) || 0, b = t.pattern ? t.pattern.width * t.pattern.scaleX + Math.abs(A) : 0, p = t.pattern ? t.pattern.height * t.pattern.scaleY + Math.abs(B) : 0, D = t.dataWidth || b || _, N = t.dataHeight || p || Dt, L = t.pattern ? t.pattern.width * t.pattern.scaleX : _, K = t.pattern ? t.pattern.height * t.pattern.scaleY : Dt;
    return S(G, {
      children: [S("g", {
        mask: t.stepName ? void 0 : t.mask,
        children: [g("pattern", {
          patternUnits: t.pattern ? void 0 : "userSpaceOnUse",
          x: 0,
          y: 0,
          width: t.pattern ? 1 : _,
          height: t.pattern ? 1 : _,
          "data-frame-width": t.pattern ? D : void 0,
          "data-frame-height": t.pattern ? N : void 0,
          id: e,
          children: g("image", {
            filter: t.useThreshold ? `url(#${a})` : void 0,
            preserveAspectRatio: "none",
            x: A,
            y: B,
            width: L,
            height: K,
            xlinkHref: s()
          })
        }), m ? g(Qe, {
          path: t.path,
          width: t.width,
          height: t.height,
          focalBlurStrength: t.focalBlurStrength || 1,
          focalBlurRadius: t.focalBlurRadius || 10,
          blurFilterId: i,
          focalMaskId: r,
          blurEdgeClipId: n
        }) : null]
      }), t.useThreshold && S("filter", {
        id: a,
        "color-interpolation-filters": "sRGB",
        children: [g("feColorMatrix", {
          type: "matrix",
          values: `
                            ${t.thresholdSaturation} ${t.thresholdSaturation} ${t.thresholdSaturation} 0 0
                            ${t.thresholdSaturation} ${t.thresholdSaturation} ${t.thresholdSaturation} 0 0
                            ${t.thresholdSaturation} ${t.thresholdSaturation} ${t.thresholdSaturation} 0 0
                            0 0 0 1 0
                        `,
          result: "greyscale"
        }), S("feComponentTransfer", {
          in: "greyscale",
          children: [g("feFuncR", {
            type: "discrete",
            tableValues: o()
          }), g("feFuncG", {
            type: "discrete",
            tableValues: o()
          }), g("feFuncB", {
            type: "discrete",
            tableValues: o()
          })]
        })]
      })]
    });
  }, c = !!t.focalBlur && !!t.pattern, h = t.rotation || 0, d = P(h), u = Math.cos(d), f = -Math.sin(d);
  return S(G, {
    children: [g("defs", {
      children: l(c)
    }), g("g", {
      mask: t.stepName ? void 0 : t.mask,
      children: S("g", {
        transform: `
                matrix(1, 0, 0, 1, ${t.x}, ${t.y})
                matrix(1, 0, 0, 1, ${t.width / 2}, ${t.height / 2})
                matrix(${u}, ${-f}, ${f}, ${u}, 0, 0)
                matrix(1, 0, 0, 1, ${-t.width / 2}, ${-t.height / 2})
                matrix(${t.scaleX}, 0, 0, ${t.scaleY}, 0, 0)
                `,
        children: [g("path", {
          filter: c ? `url(#${i})` : void 0,
          mask: c ? `url(#${n})` : void 0,
          d: t.path,
          style: {
            fill: `url(#${e})`,
            opacity: t.opacity
          }
        }), c ? g("path", {
          mask: `url(#${r})`,
          d: t.path,
          style: {
            fill: `url(#${e})`,
            opacity: t.opacity
          }
        }) : void 0]
      })
    })]
  });
}, Qe = (t) => {
  const {
    path: e,
    width: i,
    height: n,
    focalBlurStrength: r,
    focalBlurRadius: a,
    blurFilterId: s,
    focalMaskId: o,
    blurEdgeClipId: l
  } = t;
  return S(G, {
    children: [g("filter", {
      id: s,
      children: g("feGaussianBlur", {
        stdDeviation: r || 0
      })
    }), g("mask", {
      id: o,
      children: g("circle", {
        cx: i / 2,
        cy: n / 2,
        r: a || 0,
        fill: "white",
        filter: `url(#${s})`
      })
    }), g("mask", {
      id: l,
      children: g("path", {
        d: e,
        style: {
          fill: "white",
          opacity: 1
        }
      })
    })]
  });
}, ct = /* @__PURE__ */ new Map();
function pt(t) {
  let e = 0;
  for (let i = 0; i < t.length; i++)
    e = (e << 5) - e + t.charCodeAt(i), e |= 0;
  return e.toString(36);
}
function Pe(t) {
  const e = pt(t);
  if (ct.has(e))
    return ct.get(e);
  const i = "http://www.w3.org/2000/svg", n = document.createElementNS(i, "svg"), r = document.createElementNS(i, "path");
  n.setAttribute("style", "width:0!important; height:0!important; position:fixed!important; overflow:hidden!important; visibility:hidden!important; opacity:0!important"), r.setAttribute("d", t), n.append(r), document.body.append(n);
  const a = r.getBBox();
  return n.remove(), ct.set(pt(t), a), a;
}
const Ne = (t) => {
  const e = `spiff-group-clip-${t.id}`, i = t.rotation || 0, n = P(i), r = Math.cos(n), a = -Math.sin(n), s = It(t.children);
  return S(G, {
    children: [g("defs", {
      children: (() => {
        const l = t.clipPath ? Pe(t.clipPath) : void 0;
        return g("clipPath", {
          id: e,
          preserveAspectRatio: "none",
          children: t.clipPath && l ? g("path", {
            d: t.clipPath,
            transform: `scale(${t.width / l.width}, ${t.height / l.height})`
          }) : g("rect", {
            x: 0,
            y: 0,
            width: t.width,
            height: t.height
          })
        });
      })()
    }), g("g", {
      transform: `
                matrix(1, 0, 0, 1, ${t.x}, ${t.y})
                matrix(1, 0, 0, 1, ${t.width / 2}, ${t.height / 2})
                matrix(${r}, ${-a}, ${a}, ${r}, 0, 0)
                matrix(1, 0, 0, 1, ${-t.width / 2}, ${-t.height / 2})
                `,
      children: s.map((l) => Kt(l)).filter((l) => !!l).map((l) => g("g", {
        clipPath: `url(#${e})`,
        children: l
      }))
    })]
  });
}, Ut = /* @__PURE__ */ new Map();
class Le {
  constructor(e) {
    this.font = e, this.glyphsFromText = /* @__PURE__ */ new Map(), this.kerningValues = /* @__PURE__ */ new Map(), this.height = this.calculateApproximateHeight();
  }
  getFont() {
    return this.font;
  }
  getGlyphs(e) {
    const i = this.glyphsFromText.get(e);
    if (i)
      return i;
    const n = this.font.stringToGlyphs(e);
    return this.glyphsFromText.set(e, n), n;
  }
  /**
   * @returns The approximate height of any text line based on all main characters of the alphabet.
   */
  getApproximateHeight() {
    return this.height;
  }
  /**
   * Computes the exact height of a line of text.
   * @param text
   * @returns
   */
  getExactHeight(e) {
    const i = this.font.stringToGlyphs(e);
    let n = 0, r = 0;
    return i.forEach((a) => {
      const s = a.getMetrics();
      n = Math.max(n, s.yMax), r = Math.min(r, s.yMin);
    }), n - r;
  }
  getKerningValue(e, i) {
    if (!e.name || !i.name)
      return;
    let n = this.kerningValues.get(e.name);
    n || (n = /* @__PURE__ */ new Map(), this.kerningValues.set(e.name, n));
    let r = n.get(i.name);
    return r || (r = this.font.getKerningValue(e, i), n.set(i.name, r)), r;
  }
  calculateApproximateHeight() {
    const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = this.font.stringToGlyphs(e);
    let n = 0, r = 0;
    return i.forEach((a) => {
      const s = a.getMetrics();
      n = Math.max(n, s.yMax), r = Math.min(r, s.yMin);
    }), n - r;
  }
}
const je = (t) => t.substring(0, 5).toLowerCase().trim() === "data:", ht = /* @__PURE__ */ new Map(), Vt = async (t) => {
  if (ht.has(t))
    return ht.get(t);
  const i = (async () => {
    try {
      return O(t).getFont();
    } catch {
      if (je(t)) {
        const n = Ht(t), r = mt.parse(n);
        return xt(t, r), r;
      } else {
        const n = await bt(t, !0), r = mt.parse(n);
        return xt(t, r), await we(r, t), r;
      }
    }
  })();
  return ht.set(t, i), i;
}, Wi = (t) => {
  const e = Ht(t), i = mt.parse(e);
  return xt(t, i), i;
}, O = (t) => {
  const e = Ut.get(t);
  if (e)
    return e;
  throw new Error("Font metrics unavailable for font");
}, xt = (t, e) => {
  const i = new Le(e);
  return Ut.set(t, i), i;
}, at = (t, e, i, n) => Math.max(ze(t.join(`
`), i, n), e), Qt = (t, e, i, n, r, a) => {
  const s = (a || Ct) * r.getApproximateHeight(), o = e.split(`
`);
  try {
    const l = o.flatMap((h) => it(h, t.width, n, r)), c = l.flatMap((h) => h.lines);
    return {
      lines: c,
      requiredHeight: l.flatMap((h) => h.lines).length * (n * s),
      fontSize: i,
      requiredWidth: at(c, t.width, n, r)
    };
  } catch {
    const c = e.split("");
    return {
      lines: c,
      requiredHeight: c.length * (n * s),
      fontSize: i,
      requiredWidth: at(c, t.width, n, r)
    };
  }
}, it = (t, e, i, n) => {
  const r = Q(t, i, n);
  if (r <= e)
    return {
      lines: [t],
      width: r
    };
  if (!(t.indexOf(" ") > -1)) {
    if (t.length <= 1)
      throw new Error(`Character ${t} is wider than region`);
    const h = Math.floor(t.length / 2), d = it(t.slice(0, h), e, i, n), u = it(t.slice(h), e, i, n);
    return {
      lines: [...d.lines, ...u.lines],
      width: Math.max(d.width, u.width)
    };
  }
  const s = t.split(" "), o = [];
  let l = -1 / 0, c = 0;
  for (; c < s.length; ) {
    const h = s[c];
    if (Q(h, i, n) > e) {
      const d = it(h, e, i, n);
      o.push(...d.lines), l = Math.max(l, d.width), c++;
    } else {
      const d = [h];
      l = Math.max(l, Q(h, i, n));
      let u = c + 1, f = !0;
      for (; u < s.length && f; ) {
        const m = s[u], A = Q(`${d.join(" ")} ${m}`, i, n);
        A <= e ? (d.push(m), l = Math.max(l, A), u++) : f = !1;
      }
      o.push(d.join(" ")), c = u;
    }
  }
  if (l < 0)
    throw new Error(`No max width calculated for text: ${o}.`);
  return {
    lines: o,
    width: l
  };
}, Oe = (t, e, i, n, r, a) => {
  const s = (a ?? Ct) * e.getApproximateHeight(), o = 1 / i.unitsPerEm, l = qt(t, o, e), c = t.length * s * o, h = n / l, d = r / c;
  return Math.min(d, h);
}, ke = (t, e, i, n) => {
  var c;
  const r = O(e.fontData.assetUrl), a = r.getFont(), s = e.fontSize / a.unitsPerEm;
  if (!i)
    return Qt(e, t, e.fontSize, s, r, n);
  let o;
  if (e.text ? o = e.text.split(`
`) : o = ((c = e.input) == null ? void 0 : c.split(`
`)) ?? [""], i.input === t && e.width === i.width && e.height === i.height && e.lineHeight === i.lineHeight)
    return {
      lines: o,
      requiredHeight: e.height,
      requiredWidth: at(o, e.width, s, r),
      fontSize: e.fontSize
    };
  const l = e.width !== i.width != (e.height !== i.height);
  return e.lineHeight === i.lineHeight && !l && i.input === t ? {
    lines: o,
    requiredHeight: e.height,
    requiredWidth: at(o, e.width, s, r),
    fontSize: Oe(o, r, a, e.width, e.height, n)
  } : Qt(e, t, e.fontSize, s, r, n);
}, We = (t, e, i, n, r) => {
  const s = O(e.assetUrl).getFont();
  let o = {
    ...t
  }, l = {
    ...t
  }, c = qt(n, i / s.unitsPerEm, O(e.assetUrl));
  return c && c < o.width && (l.width = c, r === "left" ? (l.left += Math.sin(o.rotation * Math.PI / 360) * (o.width - c), l.top += Math.sin(o.rotation * Math.PI / 180) * (c - o.width) / 2) : r === "right" ? l.left += o.width - c : l.left += (o.width - c) / 2, n && Re(n, n).every(([h, d]) => h === d) && (o = l)), o;
}, dt = 1, Q = (t, e, i) => {
  let n = 0;
  const r = i.getGlyphs(t);
  return r.forEach((a, s) => {
    if (a.advanceWidth && (n += a.advanceWidth), s < r.length - 1) {
      const o = i.getKerningValue(a, r[s + 1]);
      n += o || 0;
    }
  }), n *= e, n;
}, ze = (t, e, i) => {
  let n = 0;
  const r = i.getGlyphs(t);
  return r.forEach((a, s) => {
    if (a.advanceWidth && (n = Math.max(n, a.advanceWidth)), s < r.length - 1) {
      const o = i.getKerningValue(a, r[s + 1]);
      n = Math.max(n, o || 0);
    }
  }), n *= e, n;
}, qt = (t, e, i) => {
  let n = 0;
  return t.forEach((r) => {
    n = Math.max(n, Q(r, e, i));
  }), n;
}, Pt = {
  stripControlCharacters: !0,
  vertical: !1,
  uppercase: !1
}, He = (t, e = Pt) => {
  const i = {
    ...Pt,
    ...e
  };
  let n = t || "";
  return i.stripControlCharacters && (n = n.replace(/^(?![\u000A\u000D])[\u0000-\u001F\u007F-\u009F]/g, "")), i.uppercase && (n = n.toUpperCase()), i.vertical && (n = n.split("").join(`
`)), n;
}, Re = (t, e) => t.map((i, n) => [i, e[n]]), Ge = (t = "center", e = !1) => e ? "center" : t, Yt = (t) => t === "left" ? "start" : t === "right" ? "end" : "middle", Y = (t, e, i) => t.fontData ? {
  ...t,
  ...(() => {
    if (t.algorithm === k.Traditional) {
      const r = ke(e, t, i, t.lineHeight);
      return {
        text: r.lines.join(`
`),
        height: r.requiredHeight,
        width: r.requiredWidth,
        fontSize: r.fontSize,
        input: e
      };
    } else
      return {
        text: e
      };
  })()
} : t, Ct = 1.1, Xe = (t) => {
  var d;
  const i = (t.rotation || 0) * Math.PI / 180, n = Math.cos(i), r = -Math.sin(i), a = `text-path-${t.id}`, s = `text-fill-${t.id}`, o = t.x + (t.curved ? 0 : t.width / 2), l = t.y + (t.curved ? 0 : t.height / 2), c = (t.text || "").split(`
`);
  if (t.curved && !t.paths || !t.fontData)
    return null;
  const h = () => {
    var u;
    return t.textFillImage ? `url("#${s}")` : (u = t._renderingConfiguration) != null && u.spotColors && t.fillSpotColorDefinition ? `${t.fill} ${Ot(t.fillSpotColorDefinition)}` : t.fill;
  };
  return S(G, {
    children: [S("defs", {
      children: [t.textFillImage && g("pattern", {
        id: s,
        patternUnits: "userSpaceOnUse",
        width: t.textFillImage.scale * t.textFillImage.width,
        height: t.textFillImage.scale * t.textFillImage.height,
        x: 0,
        y: 0,
        children: g("image", {
          href: t.textFillImage.src,
          xlinkHref: t.textFillImage.src,
          width: t.textFillImage.scale * t.textFillImage.width,
          height: t.textFillImage.scale * t.textFillImage.height
        })
      }), g("style", {
        type: "text/css",
        dangerouslySetInnerHTML: {
          __html: `
                        @font-face {
                            font-family: '${t.fontData.name}';
                            src: url('${t.fontData.assetUrl}') format('truetype');
                        }
                        `
        }
      }), t.curved && t.paths ? g("path", {
        id: a,
        d: t.paths[0]
      }) : void 0]
    }), (d = t._renderingConfiguration) != null && d.debug ? g("rect", {
      stroke: "blue",
      fill: "none",
      x: t.x,
      y: t.y,
      width: t.width,
      height: t.height
    }) : void 0, g("g", {
      mask: t.stepName ? void 0 : t.mask,
      children: g("g", {
        transform: `matrix(${n}, ${-r}, ${r}, ${n}, ${o}, ${l})`,
        children: g("text", {
          xmlSpace: "preserve",
          fontFamily: `'${t.fontData.name}'`,
          fontSize: t.fontSize,
          fontStyle: "normal",
          fontWeight: "normal",
          fill: h(),
          style: {
            whiteSpace: "pre",
            userSelect: "none"
          },
          children: t.curved ? g(Ue, {
            text: t.text || "",
            curvedPathId: a,
            align: t.align
          }) : c.map((u, f) => g(Te, {
            align: t.vertical ? "center" : t.align,
            fontSize: t.fontSize,
            thisLineIdx: f,
            amountLines: c.length,
            text: u,
            textboxHeight: t.height,
            textboxWidth: t.width,
            lineHeight: t.lineHeight,
            vertical: t.vertical,
            verticalAlign: t.verticalAlign
          }, f))
        })
      })
    })]
  });
}, Te = (t) => {
  const e = () => t.lineHeight !== void 0 ? t.lineHeight : Ct, i = () => t.align === "left" ? -t.textboxWidth / 2 : t.align === "right" ? t.textboxWidth / 2 : 0, n = () => {
    const r = t.fontSize * e(), a = t.textboxHeight / 2;
    if (t.verticalAlign === "top")
      return -a + t.fontSize * 3 / 4 + t.thisLineIdx * r;
    if (t.verticalAlign === "bottom") {
      const o = t.amountLines - 1 - t.thisLineIdx;
      return a - t.fontSize / 4 - o * r;
    }
    const s = (t.amountLines - 1) / 2;
    return (t.thisLineIdx - s) * r + t.fontSize / 4;
  };
  return g("tspan", {
    textAnchor: Yt(t.align),
    x: i(),
    y: `${n()}px`,
    children: t.text
  });
}, Ue = (t) => {
  const e = `#${t.curvedPathId}`;
  return g("textPath", {
    startOffset: (() => t.align === "left" ? "0%" : t.align === "right" ? "100%" : "50%")(),
    textAnchor: Yt(t.align),
    href: e,
    xlinkHref: e,
    children: t.text
  });
}, Ve = (t) => {
  var s, o;
  if (t.cachedObjectURL && !((s = t._renderingConfiguration) != null && s.omitCachedFields))
    return g(jt, {
      id: t.id,
      src: t.cachedObjectURL,
      x: t.x,
      y: t.y,
      width: t.width,
      height: t.height,
      rotation: t.rotation,
      preserveAspectRatio: "none",
      immutable: t.immutable,
      mask: t.stepName ? void 0 : t.mask
    });
  const e = t.rotation || 0, i = P(e), n = Math.cos(i), r = -Math.sin(i), a = `
    matrix(1, 0, 0, 1, ${t.x}, ${t.y})
    matrix(1, 0, 0, 1, ${t.width / 2}, ${t.height / 2})
    matrix(${n}, ${-r}, ${r}, ${n}, 0, 0)
    matrix(1, 0, 0, 1, ${-t.width / 2}, ${-t.height / 2})
    `;
  if (!t.svg)
    throw new Error(`Illustration element ${t.id} (stepName ${t.stepName}) lacked svg from src ${t.src} at render time.`);
  return g("g", {
    mask: t.stepName ? void 0 : t.mask,
    children: g("g", {
      transform: a,
      dangerouslySetInnerHTML: {
        __html: Tt(t.svg, t.width, t.height, t.colors, (o = t._renderingConfiguration) == null ? void 0 : o.spotColors)
      }
    })
  });
};
class zi {
  constructor() {
    this.id = v(), this.stateCallbacks = [], this.prevCommands = [], this.nextCommands = [];
  }
  registerStateCallback(e) {
    this.stateCallbacks.push(e);
  }
  unregisterStateCallback(e) {
    this.stateCallbacks.filter((i) => i !== e);
  }
  getState() {
    return this.state;
  }
  runStateCallbacks() {
    this.stateCallbacks.forEach((e) => e());
  }
  apply(e, i) {
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    this.state = this.commandReducer(this.state, e), this.runStateCallbacks(), this.nextCommands = [], i || this.prevCommands.push(e);
  }
  undo() {
    if (!this.state)
      return;
    const e = this.prevCommands.pop();
    if (!e)
      return;
    const i = e.undo();
    e.varying ? this.state = {
      ...this.state,
      variation: i
    } : this.state = {
      ...this.state,
      transaction: i
    }, this.nextCommands.push(e), this.runStateCallbacks();
  }
  redo() {
    if (!this.state)
      return;
    const e = this.nextCommands.pop();
    e && (this.state = this.commandReducer(this.state, e), this.runStateCallbacks(), this.prevCommands.push(e));
  }
  /**
   * Find all commands in history with the given sequence ID,
   * discard all but the last and overwrite its oldState.
   */
  flattenSequence(e, i) {
    const r = this.prevCommands.filter((a) => a.sequenceId === e).pop();
    r && (this.prevCommands = this.prevCommands.filter((a) => a.sequenceId !== e), r == null || r.overrideOldState(i), this.prevCommands.push(r));
  }
  getLayoutById(e) {
    var s, o, l, c;
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const i = (o = (s = this.state.transaction) == null ? void 0 : s.layouts) == null ? void 0 : o[e], n = (c = (l = this.state.variation) == null ? void 0 : l.layouts) == null ? void 0 : c[e], r = (i == null ? void 0 : i.layout) || (n == null ? void 0 : n.layout);
    if (!r)
      throw new Error(`No layout: ${e}`);
    const a = [...(i == null ? void 0 : i.elements) || [], ...(n == null ? void 0 : n.elements) || []];
    return this.getLayoutDataWithState(r, a);
  }
  getAllLayouts() {
    var n, r;
    if (!this.state)
      throw new Error(`State not initialized for cc ${this.id}!`);
    const e = [...Object.keys((n = this.state.transaction) == null ? void 0 : n.layouts), ...Object.keys(((r = this.state.variation) == null ? void 0 : r.layouts) || {})];
    return [...new Set(e)].map((a) => this.getLayoutById(a));
  }
  getLayoutDataWithState(e, i) {
    return {
      layoutState: {
        layout: e,
        elements: i
      },
      getComponentWithProps: (n) => qe(e, i, n)
    };
  }
  initialize(e, i) {
    if (i) {
      this.state = {
        transaction: i
      };
      return;
    }
    let n = {
      serializableWorkflow: {
        steps: []
      },
      layouts: {}
    };
    e.forEach((r) => {
      n = new Ye(r).apply(n);
    }), this.runStateCallbacks(), this.state = {
      transaction: n
    };
  }
  commandReducer(e, i) {
    if (i.varying) {
      const n = {
        layouts: {},
        serializableWorkflow: {
          steps: []
        },
        ...e.variation
      };
      return {
        ...e,
        variation: i.apply(n)
      };
    } else {
      const n = e.transaction || {
        layouts: {},
        serializableWorkflow: {
          steps: []
        }
      };
      return {
        ...e,
        transaction: i.apply(n)
      };
    }
  }
}
const Kt = (t) => t.type === x.Image ? g(jt, {
  ...t
}, t.id) : t.type === x.Frame ? g(pe, {
  ...t
}, t.id) : t.type === x.Illustration ? g(Ve, {
  ...t
}, t.id) : t.type === x.Textbox ? g(Xe, {
  ...t
}, t.id) : t.type === x.Group ? g(Ne, {
  ...t
}, t.id) : null, qe = (t, e, i) => {
  const n = i.renderingConfiguration, r = n != null && n.removeExcludedElements ? e.filter((a) => !a.excludeFromExport) : e;
  return g(me, {
    preserveAspectRatio: void 0,
    elements: r,
    backgroundColor: t.transparentBackground ? void 0 : i.backgroundColor ? i.backgroundColor : "white",
    width: i.width || t.width,
    height: i.height || t.height,
    viewBox: n != null && n.region ? {
      x: n.region.left,
      y: n.region.top,
      width: n.region.width,
      height: n.region.height
    } : {
      x: 0,
      y: 0,
      width: t.width,
      height: t.height
    },
    configuration: n,
    outlineArea: i.outlineArea,
    maxHeight: i.maxHeight,
    maxWidth: i.maxWidth,
    position: i.position,
    borderRadius: i.borderRadius,
    outlineColor: i.outlineColor
  });
};
function It(t) {
  return t.sort((e, i) => {
    const n = e.layer || 0, r = i.layer || 0;
    if (n < r)
      return -1;
    if (n > r)
      return 1;
    const a = e.layerIndex || 0, s = i.layerIndex || 0;
    return a < s ? -1 : a > s ? 1 : 0;
  });
}
class w extends Error {
  constructor() {
    super("Element not found!"), Object.setPrototypeOf(this, w.prototype);
  }
}
const E = (t, e) => I(t, e).elements.find((r) => r.id === t), I = (t, e) => {
  const i = Object.values(e).find((n) => n.elements.some((r) => r.id === t));
  if (!i)
    throw new w();
  return i;
}, F = (t, e) => {
  const i = [...e.elements.filter((r) => r.id !== t.id), t], n = It(i);
  return {
    layout: e.layout,
    elements: n,
    modificationID: v()
  };
}, Hi = async (t, e) => {
  const i = [...Object.keys(t.layouts), ...Object.keys((e == null ? void 0 : e.layouts) || {})], n = [...new Set(i)];
  for (let r = 0; r < n.length; r++) {
    const a = n[r], s = t.layouts[a], o = e == null ? void 0 : e.layouts[a], l = s || o;
    await Promise.all(l.elements.map(async (c) => {
      var h, d, u;
      if (c.type === "illustration") {
        const f = c;
        if (f.src && !f.svg) {
          const m = await X(f.src), A = await rt(m);
          f.svg = Tt(A.svg, f.width, f.height, f.colors);
        }
      } else if (c.type === "frame") {
        const f = c;
        if ((h = f.pattern) != null && h.colors && ((d = f.pattern) != null && d.src)) {
          const m = await X((u = f.pattern) == null ? void 0 : u.src), A = await rt(m);
          f.pattern.svg = A.svg;
        }
      }
      isNaN(c.x) && (c.x = 0), isNaN(c.y) && (c.y = 0), isNaN(c.width) && (c.width = 0), isNaN(c.height) && (c.height = 0), isNaN(c.rotation) && (c.rotation = 0);
    }));
  }
};
class y {
  undo() {
    if (!this.oldState)
      throw new Error("Cannot undo.");
    return this.oldState;
  }
  overrideOldState(e) {
    this.oldState = e;
  }
}
class Ri extends y {
  constructor(e) {
    super(), this.serializableWorkflow = e;
  }
  apply(e) {
    return this.oldState = e, {
      ...e,
      serializableWorkflow: this.serializableWorkflow
    };
  }
}
class Gi extends y {
  constructor(e, i, n) {
    super(), this.id = e, this.x = i, this.y = n;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      x: this.x,
      y: this.y
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class Xi extends y {
  constructor(e, i) {
    super(), this.id = e, this.angle = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      rotation: this.angle
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class Ti extends y {
  constructor(e, i, n) {
    super(), this.id = e, this.width = Math.abs(i), this.height = Math.abs(n);
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    let n = {
      ...i,
      width: this.width,
      height: this.height
    };
    if (i.type === "frame") {
      const s = n;
      s.scaleX = s.scaleX * this.width / i.width, s.scaleY = s.scaleY * this.height / i.height;
    } else if (i.type === "textbox") {
      const s = n, o = (!s.algorithm || s.algorithm === k.Autosize ? s.text : s.input) ?? "";
      n = Y(s, o, i);
    }
    const r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class Ui extends y {
  constructor(e) {
    super(), this.commands = e;
  }
  apply(e) {
    return this.oldState = e, this.commands.reduce((i, n) => n.apply(i), e);
  }
}
class Ye extends y {
  constructor(e) {
    super(), this.layout = e;
  }
  apply(e) {
    return this.oldState = e, {
      ...e,
      layouts: {
        ...e.layouts,
        [this.layout.id]: {
          elements: [],
          layout: {
            ...this.layout
          },
          modificationID: v()
        }
      }
    };
  }
}
class Vi extends y {
  constructor(e) {
    super(), this.panelName = e;
  }
  apply(e) {
    this.oldState = e;
    const i = Object.values(e.layouts).map((r) => {
      const a = r.layout.panelId === this.panelName;
      return {
        ...r,
        elements: a ? [] : [...r.elements],
        modificationID: v()
      };
    }), n = {};
    return i.forEach((r) => {
      n[r.layout.id] = r;
    }), {
      ...e,
      layouts: n
    };
  }
}
class Ke extends y {
  /**
   * @param initialParams The initial parameters to be set on this new object
   * @param callback An optional callback function to be notified when the object has been instantiated
   * @param layout
   */
  constructor(e, i) {
    super(), this.element = e, this.layout = i;
  }
  apply(e) {
    this.oldState = e, e.layouts[this.layout.id] || (e.layouts[this.layout.id] = {
      layout: this.layout,
      elements: [],
      modificationID: ""
    });
    const i = e.layouts[this.layout.id].elements;
    if (i.find((o) => o.id === this.element.id))
      throw new Error(`Failed to apply new ${this.element.type} element because ID ${this.element.id} already taken`);
    if (this.element.productOverlay || i.length === 0) {
      const o = [...i, this.element];
      return this.element.layerIndex === void 0 && (this.element.layerIndex = this.assignIndex(this.element, o)), {
        ...e,
        layouts: {
          ...e.layouts,
          [this.layout.id]: {
            ...e.layouts[this.layout.id],
            elements: o,
            modificationID: v()
          }
        }
      };
    }
    const r = i[i.length - 1], a = r.productOverlay ? r : null;
    a && i.pop();
    let s;
    if (this.element.layerIndex !== null && this.element.layerIndex !== void 0)
      s = [...i, this.element].sort((o, l) => o.layerIndex !== void 0 && l.layerIndex !== void 0 ? o.layerIndex - l.layerIndex : 0);
    else {
      const o = this.assignIndex(this.element, i);
      this.element.layerIndex = o !== void 0 ? o : 0, s = [...i, this.element];
    }
    return a && s.push(a), {
      ...e,
      layouts: {
        ...e.layouts,
        [this.layout.id]: {
          ...e.layouts[this.layout.id],
          elements: s,
          modificationID: v()
        }
      }
    };
  }
  // Calculate layer index for an element that doesn't have an explicit index.
  assignIndex(e, i) {
    var r;
    if (i.length === 0)
      return 0;
    const n = (r = i.filter((a) => (a.layer || 0) === (e.layer || 0)).sort((a, s) => (a.layerIndex || 0) - (s.layerIndex || 0))[i.length - 1]) == null ? void 0 : r.layerIndex;
    return n !== void 0 ? n + 1 : 0;
  }
}
class qi extends y {
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    this.oldState = e;
    let i = !1;
    const n = Object.values(e.layouts).map((a) => (a.elements.filter((o) => o.id !== this.id).length !== a.elements.length && (i = !0), {
      ...a,
      elements: a.elements.filter((o) => o.id !== this.id),
      modificationID: v()
    }));
    i || console.log(`Failed to delete element ${this.id}`);
    const r = {};
    return n.forEach((a) => {
      r[a.layout.id] = a;
    }), {
      ...e,
      layouts: r
    };
  }
}
class Yi extends y {
  constructor(e, i) {
    super(), this.el = ee(e), this.layout = i, this.el.id = v(), this.el.x += 5, this.el.y += 5;
  }
  apply(e) {
    return this.oldState = e, new Ke(this.el, this.layout).apply(e);
  }
}
class Ki extends y {
  constructor(e, i, n) {
    super(), this.id = e, this.color = i, this.textFillSpotColor = n;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      fill: this.color,
      fillSpotColorDefinition: this.textFillSpotColor,
      textFillImage: void 0
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class $i extends y {
  constructor(e, i) {
    super(), this.id = e, this.imageFill = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      textFillImage: this.imageFill
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class Zi extends y {
  constructor(e, i) {
    super(), this.id = e, this.size = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      fontSize: this.size
    }, r = I(i.id, Object.values(e.layouts)), a = (!i.algorithm || i.algorithm === k.Autosize ? i.text : i.input) ?? "", s = F(Y(n, a), r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: s
      }
    };
  }
}
class Ji extends y {
  constructor(e, i) {
    super(), this.id = e, this.algorithm = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      algorithm: this.algorithm
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class _i extends y {
  constructor(e, i) {
    super(), this.id = e, this.fontData = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      fontData: this.fontData
    }, r = I(i.id, Object.values(e.layouts)), a = (!i.algorithm || i.algorithm === k.Autosize ? i.text : i.input) ?? "", s = F(Y(n, a), r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: s
      }
    };
  }
}
class tn extends y {
  constructor(e, i) {
    super(), this.id = e, this.align = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      align: this.align
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class en extends y {
  constructor(e, i, n) {
    super(), this.id = e, this.imageData = i, this.offsets = n;
  }
  apply(e) {
    this.oldState = e;
    const i = I(this.id, Object.values(e.layouts)), n = i.elements.findIndex((o) => o.id === this.id), r = i.elements[n].pattern, a = [...i.elements];
    a.splice(n, 1, {
      ...i.elements[n],
      pattern: {
        ...r,
        src: this.imageData.src,
        x: this.offsets.x,
        y: this.offsets.y,
        width: this.imageData.width,
        height: this.imageData.height,
        scaleX: this.offsets.zoom,
        scaleY: this.offsets.zoom,
        svg: this.imageData.svg,
        colors: this.imageData.colors
      }
    });
    const s = {
      ...i,
      elements: a,
      modificationID: v()
    };
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [i.layout.id]: s
      }
    };
  }
}
class nn extends y {
  constructor(e, i, n, r, a) {
    super(), this.id = e, this.useThreshold = i, this.invertThreshold = n, this.threshold = r, this.thresholdSaturation = a;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      useThreshold: this.useThreshold,
      invertThreshold: this.invertThreshold,
      threshold: this.threshold,
      thresholdSaturation: this.thresholdSaturation
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class rn extends y {
  constructor(e, i) {
    super(), this.id = e, this.src = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      src: this.src
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class an extends y {
  constructor(e, i) {
    super(), this.id = e, this.text = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = I(i.id, Object.values(e.layouts)), r = F(Y(i, this.text, i), n);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: r
      }
    };
  }
}
class sn extends y {
  constructor(e, i, n) {
    super(), this.id = e, this.className = i, this.fill = n;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = i.colors || {}, r = n[this.className];
    n[this.className] = {
      browserValue: this.fill,
      spotColor: r == null ? void 0 : r.spotColor
    };
    const a = {
      ...i,
      colors: n
    }, s = I(i.id, Object.values(e.layouts)), o = F(a, s);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [s.layout.id]: o
      }
    };
  }
}
class on extends y {
  constructor(e, i, n) {
    super(), this.id = e, this.svgBody = i, this.objectURL = n;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = {
      ...i,
      svg: this.svgBody,
      cachedObjectURL: this.objectURL
    }, r = I(i.id, Object.values(e.layouts)), a = F(n, r);
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [r.layout.id]: a
      }
    };
  }
}
class ln extends y {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !E(this.id, Object.values(e.layouts)).id)
      throw new w();
    const n = Object.values(e.layouts).find((s) => s.elements.find((o) => o.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const r = n.elements.findIndex((s) => s.id === this.id);
    n.elements.push(n.elements.splice(r, 1)[0]);
    const a = [...n.elements];
    return a.forEach((s, o) => s.layerIndex = o), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: a,
          modificationID: v()
        }
      }
    };
  }
}
class cn extends y {
  /**
   * @param id The targeted element to bring to the back.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = Object.values(e.layouts).find((o) => o.elements.find((l) => l.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const r = n.elements.findIndex((o) => o.id === this.id);
    n.elements.splice(r, 1), n.elements.unshift(i);
    const a = [...n.elements], s = a.splice(r, 1)[0];
    return a.splice(r, 0, s), a.forEach((o, l) => o.layerIndex = l), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: a,
          modificationID: v()
        }
      }
    };
  }
}
class hn extends y {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !E(this.id, Object.values(e.layouts)).id)
      throw new w();
    const n = Object.values(e.layouts).find((l) => l.elements.find((c) => c.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const r = n.elements.findIndex((l) => l.id === this.id), a = r + 1, s = [...n.elements], o = s.splice(r, 1)[0];
    return s.splice(a, 0, o), s.forEach((l, c) => l.layerIndex = c), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: s,
          modificationID: v()
        }
      }
    };
  }
}
class dn extends y {
  /**
   * @param id The targeted element to bring to the front.
   */
  constructor(e) {
    super(), this.id = e;
  }
  apply(e) {
    if (this.oldState = e, !E(this.id, Object.values(e.layouts)).id)
      throw new w();
    const n = Object.values(e.layouts).find((l) => l.elements.find((c) => c.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    const r = n.elements.findIndex((l) => l.id === this.id), a = r - 1, s = [...n.elements], o = s.splice(r, 1)[0];
    return s.splice(a, 0, o), s.forEach((l, c) => l.layerIndex = c), {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: {
          ...e.layouts[n.layout.id],
          elements: s,
          modificationID: v()
        }
      }
    };
  }
}
class un extends y {
  /**
   * @param id The targeted element to change layer of.
   * @param value The new layer to set this element within.
   */
  constructor(e, i) {
    super(), this.id = e, this.value = i;
  }
  apply(e) {
    this.oldState = e;
    const i = E(this.id, Object.values(e.layouts));
    if (!i.id)
      throw new w();
    const n = Object.values(e.layouts).find((r) => r.elements.find((a) => a.id === this.id));
    if (!n)
      throw new Error("Layout missing from state!");
    return {
      ...e,
      layouts: {
        ...e.layouts,
        [n.layout.id]: F({
          ...i,
          layer: this.value
        }, n)
      }
    };
  }
}
let vt, Et;
const st = (t, e, i) => {
  if (vt !== void 0)
    return vt(t, e, i);
  try {
    const n = Zt(!0);
    return $t(n), n.createCanvas(t, e, i);
  } catch {
    throw new Error("Canvas module not set");
  }
}, Bt = (t, e) => {
  if (Et !== void 0)
    return Et(t, e);
  try {
    const i = Zt(!0);
    return $t(i), i.loadImage(t, e);
  } catch {
    throw new Error("Canvas module not set");
  }
};
function $t(t) {
  vt = t == null ? void 0 : t.createCanvas, Et = t == null ? void 0 : t.loadImage;
}
function Zt(t) {
  try {
    if (document.createElement("canvas").getContext("2d"))
      return {
        createCanvas: (i, n, r) => {
          const a = document.createElement("canvas");
          return i != null && (a.width = i), n != null && (a.height = n), a;
        },
        loadImage: (i, n) => new Promise((r, a) => {
          const s = document.createElement("img");
          n !== !1 && (s.crossOrigin = "Anonymous"), s.onload = () => {
            r(s);
          }, s.onerror = a, s.src = i;
        })
      };
  } catch (e) {
    if (t)
      throw e;
  }
}
let nt;
function $e() {
  return nt === void 0 && (nt = DOMParser), nt;
}
function gn(t) {
  nt = t;
}
let tt = null;
const Ze = (t) => new Promise((e) => {
  var r;
  if (q(t) !== "image/jpeg")
    return e(1);
  const n = (r = ae.load(t).Orientation) == null ? void 0 : r.value;
  return e(n ? Number(n) : 1);
}), Je = async () => {
  if (tt !== null)
    return !tt;
  const e = await Bt("data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAAAAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAIAAwMBEQACEQEDEQH/xABRAAEAAAAAAAAAAAAAAAAAAAAKEAEBAQADAQEAAAAAAAAAAAAGBQQDCAkCBwEBAAAAAAAAAAAAAAAAAAAAABEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AG8T9NfSMEVMhQvoP3fFiRZ+MTHDifa/95OFSZU5OzRzxkyejv8ciEfhSceSXGjS8eSdLnZc2HDm4M3BxcXwH/9k=");
  return tt = e.width === 2 && e.height === 3, !tt;
}, _e = (t) => {
  const i = t.naturalWidth / t.naturalHeight;
  return t.naturalHeight <= 8192 && t.naturalWidth <= 8192 ? [t.naturalWidth, t.naturalHeight] : t.naturalHeight > t.naturalWidth ? [i * 8192, 8192] : [8192, 8192 / i];
}, ti = async (t) => {
  var d;
  const e = await ve(t), i = await Bt(e), [n, r] = _e(i);
  if (!await Je()) {
    const u = st(n, r);
    return (d = u.getContext("2d")) == null || d.drawImage(i, 0, 0, n, r), u;
  }
  const s = await Ze(t), [o, l] = s > 4 ? [r, n] : [n, r], c = st(o, l), h = c.getContext("2d");
  switch (s) {
    case 2:
      h.translate(o, 0), h.scale(-1, 1);
      break;
    case 3:
      h.translate(o, l), h.rotate(Math.PI);
      break;
    case 4:
      h.translate(0, l), h.scale(1, -1);
      break;
    case 5:
      h.rotate(-0.5 * Math.PI), h.scale(-1, 1);
      break;
    case 6:
      h.rotate(-0.5 * Math.PI), h.translate(-o, 0);
      break;
    case 7:
      h.rotate(-0.5 * Math.PI), h.translate(-o, l), h.scale(1, -1);
      break;
    case 8:
      h.rotate(0.5 * Math.PI), h.translate(0, -l);
      break;
  }
  return h.drawImage(i, 0, 0, o, l), c;
}, Jt = async (t) => {
  const e = await ti(t);
  return q(t) === "image/jpeg" ? {
    dataUrl: e.toDataURL("image/jpeg", 1),
    height: e.height,
    width: e.width
  } : {
    dataUrl: e.toDataURL(),
    height: e.height,
    width: e.width
  };
}, ei = (t) => {
  const e = t.variants;
  if (e) {
    if (e.length === 1)
      return e[0];
    if (t.defaultVariant !== void 0)
      return e.find((i) => i.id === t.defaultVariant);
  }
}, z = /* @__PURE__ */ new Map(), et = /* @__PURE__ */ new Map(), ut = /* @__PURE__ */ new Map(), ii = async (t, e) => {
  if (!e) {
    if (!t)
      throw new Error("No region or src supplied. Cannot construct frame!");
    return ni(t);
  }
  return X(e);
}, ni = (t) => {
  const e = t.width, i = t.height, n = e / i, r = Math.max(e, 512), a = r / n;
  return `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${r} ${a}'>
        <path id="target-path" d='M0 0 h ${r} v ${a} h ${-r} Z' />
    </svg>
    `;
}, fn = (t, e) => {
  var n;
  if (!e)
    return;
  const i = ((n = e.variants) == null ? void 0 : n.find((r) => r.id === t.frameVariantId)) || ei(e);
  if (!i)
    throw new Error(`No variant with ID: ${t.frameVariantId}`);
  if (!i.asset)
    throw new Error(`No asset for variant with ID: ${t.frameVariantId}`);
  return i;
}, ri = async (t) => {
  if (ut.has(t))
    return ut.get(t);
  const i = (async () => {
    if (et.has(t))
      return et.get(t);
    await new Promise((u) => setTimeout(u, 0));
    const r = W().parseFromString(t, "image/svg+xml"), a = r.querySelector("svg");
    if (!a)
      throw new Error("Malformed frame SVG: <svg> tag not found");
    const s = a.getAttribute("viewBox");
    if (!s)
      throw new Error("SVG missing viewBox.");
    const o = s.split(" "), l = parseFloat(o[3]) || 1, c = parseFloat(o[2]) || 1, h = r.getElementById("target-path"), d = r.getElementsByClassName("st0").item(0);
    if (h) {
      const u = h.getAttribute("d");
      if (!u)
        throw new Error("Malformed frame SVG: 'd' attribute not found on target element");
      const f = {
        path: u,
        width: c,
        height: l
      };
      return et.set(u, f), f;
    }
    if (d) {
      const u = d.getAttribute("d");
      if (!u)
        throw new Error("Malformed frame SVG: 'd' attribute not found on target element");
      const f = {
        path: u,
        width: c,
        height: l
      };
      return et.set(u, f), f;
    }
    throw new Error("Malformed frame SVG");
  })();
  return ut.set(t, i), i;
}, mn = (t, e, i) => {
  const n = e.width / e.height, r = t.width / t.height;
  let a;
  r > n ? a = e.width / t.width : a = e.height / t.height, (i == null ? void 0 : i.scale) !== void 0 && (a *= i == null ? void 0 : i.scale);
  const s = e.width / 2, o = e.height / 2, l = s - t.width / 2 * a, c = (i == null ? void 0 : i.left) || l, h = o - t.height / 2 * a, d = (i == null ? void 0 : i.top) || h;
  return {
    x: c,
    y: d,
    zoom: a
  };
}, An = async (t) => {
  var i;
  if (z.has(t))
    return z.get(t);
  if (t.startsWith("data:image/svg+xml")) {
    const n = se(t), r = new TextDecoder().decode(n.buffer), a = _t(r), s = {
      src: t,
      width: a.width,
      height: a.height,
      aspect: a.width / a.height
    };
    return z.set(t, s), s;
  }
  const e = ((i = t.split(".").pop()) == null ? void 0 : i.toLowerCase()) ?? "";
  if (e === "svg") {
    const n = await ai(t), r = n.width, a = n.height, s = {
      src: t,
      width: r,
      height: a,
      aspect: r / a
    };
    return z.set(t, s), s;
  } else {
    const n = await bt(t, !0), r = q(n), a = e === "jpg" || e === "jpeg";
    if (!r.endsWith(e) && r === "image/jpeg" && !a)
      throw Error(`File ${t} has wrong extension for mime type ${r}`);
    const s = await Jt(n), o = {
      src: t,
      width: s.width,
      height: s.height,
      aspect: s.width / s.height
    };
    return z.set(t, o), o;
  }
}, ai = async (t) => {
  const e = await X(t);
  return _t(e);
}, Nt = (t) => t.endsWith("mm") ? Number(t.replace("mm", "")) * 3.7795275591 : t.endsWith("px") ? Number(t.replace("px", "")) : Number(t), _t = (t) => {
  const n = W().parseFromString(t, "image/svg+xml").querySelector("svg");
  if (!n)
    throw new Error("No svg tag found, this svg must be malformed!");
  const r = n.getAttribute("viewBox"), a = n.getAttribute("width"), s = n.getAttribute("height"), o = s && a ? [0, 0, Nt(a), Nt(s)] : r == null ? void 0 : r.split(" ").map((l) => Number(l));
  if (!o)
    throw new Error("No viewbox or width/height values detected on SVG file!");
  return {
    width: o[2],
    height: o[3]
  };
}, gt = (t, e, i, n, r) => {
  if (e.some((h) => h == null))
    throw new Error(`Failed to autosize lines: ${e.join(", ")}`);
  let a = e.map((h) => h.split(`
`)).flat(), s = a.length, o = a.map((h) => Q(h, n, r));
  const l = r.getApproximateHeight() * n;
  let c = !0;
  for (; c; ) {
    if (l + (s - 1) * i > t.height)
      return [null, null];
    const d = Math.max(...o);
    if (d <= t.width)
      return [a, d];
    const u = o.reduce((B, b, p, D) => b > D[B] ? p : B, 0), f = a[u];
    let m = !1, A = f.length;
    for (; !m && A > -1; ) {
      A = f.lastIndexOf(" ", A - 1);
      const B = [f.slice(0, A), f.slice(A + 1)], b = B.map((D) => Q(D, n, r));
      b[0] <= t.width && (a = [...a.slice(0, u), ...B, ...a.slice(u + 1)], o = [...o.slice(0, u), ...b, ...o.slice(u + 1)], s += 1, m = !0);
    }
    m || (c = !1);
  }
  return [null, null];
}, Lt = (t, e, i, n, r) => {
  let a, s;
  const o = O(e.assetUrl), l = o.getFont();
  if (r.size) {
    const u = t / l.unitsPerEm;
    return [a, s] = gt(i, n, t, u, o), [r.size, a, s];
  }
  const c = 6;
  let h = c - dt;
  if (n.length > 0) {
    let u = n, f = 0;
    for (; (!r.maxSize || h <= r.maxSize) && u; )
      h += dt, f = h / l.unitsPerEm, [u, s] = gt(i, n, h, f, o);
  }
  h > c && (h -= dt), r.minSize && h < r.minSize && (h = r.minSize);
  const d = h / l.unitsPerEm;
  return [a, s] = gt(i, n, h, d, o), [h, a, s];
}, si = (t, e) => t.map((i, n) => [i, e[n]]), yn = (t, e, i, n, r) => {
  let a = {
    ...t
  }, s = {
    ...t
  }, [o, l, c] = Lt(i, e, s, n, {
    size: 0,
    minSize: i,
    maxSize: i
  });
  return c && c < a.width && (s.width = c, r === "left" ? (s.left += Math.sin(a.rotation * Math.PI / 360) * (a.width - c), s.top += Math.sin(a.rotation * Math.PI / 180) * (c - a.width) / 2) : r === "right" ? s.left += a.width - c : s.left += (a.width - c) / 2, [o, l] = Lt(i, e, s, n, {
    size: i
  }), o === i && l && si(n, l).every(([h, d]) => h === d) && (a = s)), a;
}, H = (t, e) => {
  const i = t.layoutState.elements.filter((r) => r.layer === e), n = Math.max(...i.map((r) => r.layerIndex).filter((r) => r !== void 0));
  return Math.max(n, 0) + 1;
}, te = async (t) => new Promise((e) => {
  X(t).then((i) => {
    e(i);
  }).catch((i) => console.error(i));
}), ft = /* @__PURE__ */ new Map(), oi = async (t) => {
  if (ft.has(t))
    return ft.get(t);
  const e = async (r) => new Promise((a, s) => {
    try {
      if (!(!!URL && !!URL.createObjectURL))
        throw new Error("Environment incapable of generating ObjectURL");
      r.toBlob((l) => {
        if (!l)
          throw r.width === 0 || r.height === 0 ? new Error(`Canvas dimensions are invalid (${r.width},${r.height})`) : r.width * r.height >= 268435456 ? new Error(`Canvas dimensions exceed device limit (${r.width},${r.height})`) : new Error("Couldn't generate object URL for Illustration, the blob was undefined!");
        a(URL.createObjectURL(l));
      });
    } catch (o) {
      s(o);
    }
  }), n = (async () => {
    const s = W().parseFromString(t, "image/svg+xml").firstElementChild;
    if (!s)
      throw new Error("Failed to read SVG");
    const l = new XMLSerializer().serializeToString(s), c = st(), h = c.getContext("2d"), d = await oe.from(h, l, {
      anonymousCrossOrigin: !0,
      ignoreDimensions: !1,
      createCanvas: st,
      createImage: Bt,
      DOMParser: $e(),
      fetch: U
    }), u = s.getAttribute("width"), f = s.getAttribute("height"), m = 2048;
    if (f && u) {
      const A = parseFloat(f), b = parseFloat(u) / A;
      b > 1 ? d.resize(m, m / b) : d.resize(m * b, m);
    } else
      d.resize(m, m);
    return await d.render(), await e(c);
  })();
  return ft.set(t, n), n;
}, R = async (t, e, i, n) => {
  const r = t.layoutState.layout.useEditableArea && t.layoutState.layout.editableArea || {
    width: t.layoutState.layout.width,
    height: t.layoutState.layout.height,
    x: 0,
    y: 0
  }, a = r.width < r.height ? r.width : r.height, s = t.layoutState.layout.useEditableArea ? a / 1.3 : a / 2, o = {
    top: r.y + r.height / 2 - s / 2,
    left: r.x + r.width / 2 - s / 2,
    width: s,
    height: s,
    rotation: 0,
    panelId: t.layoutState.layout.panelId
  };
  if (i && e === x.Illustration) {
    const l = await rt(await te(i)), u = W().parseFromString(l.svg, "image/svg+xml").firstElementChild.getAttribute("viewBox");
    if (!u)
      throw new Error("SVG missing viewBox.");
    const f = o.height, m = u.split(" "), A = parseFloat(m[2]) || 1, B = parseFloat(m[3]) || 1, b = A / B;
    o.height = o.width / b, o.top += (f - o.height) / 2;
  }
  if (i && e === x.Image) {
    const l = o.height, c = await bt(i), h = await Jt(c), d = h.width / h.height;
    o.height = o.width / d, o.top += (l - o.height) / 2;
  }
  if (i && e === x.Textbox && (n != null && n.text) && (n != null && n.fontScale)) {
    await Vt(i);
    const l = O(i), c = Q(n.text, n == null ? void 0 : n.fontScale, l);
    o.width = Math.min(c, r.width * 0.85), o.left = r.x + r.width / 2 - o.width / 2;
  }
  return o;
};
class wn {
  static async getFrame(e, i) {
    const n = await ii(i.region, i.src), r = await ri(n), a = i.region || await R(e, x.Frame);
    return {
      id: v(),
      x: a.left,
      y: a.top,
      width: a.width,
      height: a.height,
      layer: a.layer || 0,
      layerIndex: a.layerIndex || H(e, a.layer || 0),
      rotation: a.rotation,
      scaleX: a.width / r.width,
      scaleY: a.height / r.height,
      path: r.path,
      dataWidth: r.width,
      dataHeight: r.height,
      type: x.Frame,
      disablePlaceholder: i.configuration.disablePlaceholder,
      focalBlur: i.configuration.focalBlur,
      focalBlurStrength: i.configuration.focalBlurStrength,
      focalBlurRadius: i.configuration.focalBlurRadius,
      forceImageCover: i.configuration.forceImageCover,
      pattern: void 0,
      immutable: a.immutable
    };
  }
  static async getImage(e, i) {
    const n = i.region || await R(e, x.Image, i.src);
    return {
      id: v(),
      src: i.src,
      type: x.Image,
      y: n.top,
      x: n.left,
      rotation: n.rotation,
      width: n.width,
      height: n.height,
      layer: n.layer || 0,
      layerIndex: n.layerIndex || H(e, n.layer || 0),
      immutable: n.immutable,
      preserveAspectRatio: "none"
    };
  }
  static async getTextbox(e, i) {
    var m;
    const {
      configuration: n,
      fontSrc: r,
      designInputStep: a
    } = i, s = await Vt(r), o = {
      assetUrl: r,
      name: s.names.fullName.en
    }, l = (a == null ? void 0 : a.text) || n.defaultText || "", c = n.replaceableText ? n.replaceableText.replace("{{}}", l) : l, h = He(c, {
      vertical: n.vertical,
      uppercase: n.uppercase
    }), d = i.region || await R(e, x.Textbox, r, {
      text: h,
      fontScale: n.size ? n.size / s.unitsPerEm : void 0
    }), u = Y({
      id: v(),
      type: x.Textbox,
      x: d.left,
      y: d.top,
      width: d.width,
      height: d.height,
      align: Ge(n.textAlign, n.vertical),
      curved: n.curved,
      fill: (a == null ? void 0 : a.color) || n.colour || "#000000",
      fontData: o,
      layer: d.layer || 0,
      layerIndex: d.layerIndex || H(e, d.layer || 0),
      paths: n.paths,
      rotation: d.rotation,
      vertical: n.vertical,
      verticalAlign: n.verticalAlign || "middle",
      algorithm: k.Traditional,
      fontSize: n.size || Math.max(Math.round(d.height * 0.025), 1),
      text: h,
      input: l
    }, h), f = We({
      ...d,
      height: u.height
    }, o, u.fontSize, ((m = u == null ? void 0 : u.text) == null ? void 0 : m.split(`
`)) || [], u.align);
    return {
      ...u,
      x: f.left,
      y: f.top + (d.height - f.height) / 2,
      width: f.width,
      height: f.height
    };
  }
  static async getShape(e, i) {
    const n = `
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlSpace="preserve"
                        preserveAspectRatio="none"
                        version="1.1"
                        width="1"
                        height="1"
                        viewBox="0 0 1 1"
                    >
                        <rect
                            x="0"
                            y="0"
                            width="1"
                            height="1"
                            class="spiff-fill-shape"
                            fill="${i.color}"
                        />
                    </svg>
                `, r = {};
    r["spiff-fill-shape"] = {
      browserValue: i.color
    };
    const a = i.region || await R(e, x.Illustration), s = v();
    return {
      stepRegion: i.region,
      colors: r,
      id: s,
      svg: n,
      type: x.Illustration,
      y: a.top,
      x: a.left,
      rotation: a.rotation,
      width: a.width,
      height: a.height,
      layer: a.layer || 0,
      layerIndex: a.layerIndex || H(e, a.layer || 0),
      immutable: a.immutable
    };
  }
  static async getIllustration(e, i) {
    const n = i.region || await R(e, x.Illustration, i.src), r = await rt(await te(i.src)), a = await oi(r.svg), s = v();
    return {
      cachedObjectURL: a,
      stepRegion: i.region,
      colors: r.colors,
      id: s,
      src: i.src,
      svg: r.svg,
      type: x.Illustration,
      y: n.top,
      x: n.left,
      rotation: n.rotation,
      width: n.width,
      height: n.height,
      layer: n.layer || 0,
      layerIndex: n.layerIndex || H(e, n.layer || 0),
      immutable: n.immutable
    };
  }
}
export {
  ce as AspectConditionAction,
  he as AspectType,
  ue as AssetType,
  Qe as BlurDefinitions,
  hn as BringForwardCommand,
  cn as BringToBackCommand,
  ln as BringToFrontCommand,
  y as CanvasCommand,
  Vi as ClearLayoutCommand,
  Yi as CloneElementCommand,
  zi as CommandContext,
  Ke as CreateElementCommand,
  Ye as CreateLayoutCommand,
  qi as DeleteElementCommand,
  w as ElementNotFoundError,
  Ji as FontAlgorithmCommand,
  tn as FontAlignmentCommand,
  Ki as FontColorCommand,
  $i as FontImageFillCommand,
  Le as FontMetrics,
  Zi as FontSizeCommand,
  _i as FontSourceCommand,
  pe as Frame,
  ai as GetSVGDimensions,
  Ui as GroupCommand,
  Ve as Illustration,
  on as IllustrationCacheCommand,
  sn as IllustrationColorCommand,
  jt as Image,
  un as LayerCommand,
  wn as LayoutElementFactory,
  x as LayoutElementType,
  At as LayoutRenderingPurpose,
  de as MaterialEffectMode,
  Gi as MoveCommand,
  Ti as ResizeCommand,
  Xi as RotateCommand,
  me as SVGLayout,
  C as ScaleAxis,
  dn as SendBackwardsCommand,
  fe as StepAspectType,
  ge as StepType,
  k as TextAlgorithm,
  an as TextChangeCommand,
  Xe as Textbox,
  le as UnitOfMeasurement,
  en as UpdateFramePattern,
  nn as UpdateFrameThresholdSettingsCommand,
  rn as UpdateImageSourceCommand,
  Ri as UpdateWorkflowStateCommand,
  Wi as _loadFontExternalDataURL,
  He as applyTextTransformations,
  ve as arrayBufferToDataUrl,
  mn as calculateOffsets,
  _e as canvasDims,
  ze as charWidth,
  pi as cmPerPixel,
  J as colorDefinitionPrintValue,
  st as createCanvas,
  Ni as createElement,
  Li as createElementNS,
  Si as currentDirection,
  ki as dataUrlFromExternalUrl,
  Ht as dataUrlToArrayBuffer,
  Ct as defaultLineHeightFactor,
  P as degreesToRadians,
  Lt as determineCorrectFontSizeAndLines,
  yn as determineCorrectTextboxRegion,
  Zt as documentCanvasModule,
  W as domParser,
  Kt as elementFactory,
  U as fetch,
  bt as fetchAsArrayBuffer,
  X as fetchAsString,
  wi as findAngle,
  E as findElement,
  I as findLayoutForElement,
  dt as fontSizeStep,
  et as frameDataCache,
  v as generate,
  ni as generateDefaultRectangleFrameSvg,
  ii as generateFrameSVG,
  rt as generateSVGWithUnknownColors,
  Yt as getAnchor,
  Jt as getAttributesFromArrayBuffer,
  yi as getAxisAlignedBoundingBox,
  ei as getDefaultVariant,
  $e as getDomParser,
  Mi as getElementVertices,
  Ze as getExifOrientation,
  O as getFontMetrics,
  ri as getFrameData,
  q as getMimeTypeOfArrayBuffer,
  Ii as getNEPoint,
  Ci as getNWPoint,
  An as getPatternImageData,
  bi as getPointOfRotation,
  Fi as getSEPoint,
  Bi as getSWPoint,
  qe as getSvgElement,
  Ge as getTextAlignment,
  Ei as getTrueCoordinates,
  fn as getVariant,
  vi as isCloseToValue,
  qt as lineWidth,
  Vt as loadFont,
  we as loadFontFaceSet,
  Bt as loadImage,
  Di as mmPerPixel,
  Me as modifySVGColors,
  Tt as modifySVGWithElementProperties,
  z as patternImageDataCache,
  xi as radiansToDegrees,
  We as recalculateTextboxRegion,
  Y as recomputeTextOnElement,
  ke as refitTextbox,
  Pi as registerFetchImplementation,
  Qi as registerWindowImplementation,
  Hi as rehydrateSerializedLayout,
  ji as renderPapyrusComponentAsString,
  Z as rotateAroundPoint,
  Fe as sanitizeSvgTree,
  $t as setCanvasModule,
  gn as setDomParser,
  It as sortElementsByLayersWithIndex,
  Ot as spotColorDefinitionString,
  Ft as svgColorValueToDefinition,
  oi as svgObjectURL,
  _t as svgStringDimensions,
  Ee as svgToDataUrl,
  Q as textWidth,
  Oi as toBase64,
  T as traverse,
  j as turnRightClockwise,
  F as updatedLayoutForElement,
  zt as xmlSerializer,
  Re as zip
};
